import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2584c550&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GalleryFrame: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Gallery/GalleryFrame.vue').default,RoundButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RoundButton/index.vue').default})
